import React, { useEffect, useState } from "react";
import AppBreadcrumb from "../../Shared/AppBreadcrumb";
import FecthingSpinner from "../../Shared/FecthingSpinner";
import httpService from "../../../services/http.service";
import MyOpinionLogo from "../../../assets/images/MyOpinion_Logo_Head.png";
import {
  extractResponseValidationErrors,
  formatCash,
  formatNumber,
  getUserFullName,
  numberWithSeparator,
  PERIODICITY_DAILY,
  PERIODICITY_MONTHLY,
  PERIODICITY_WEEKLY,
  PERIODICITY_YEARLY,
} from "../../../utils/index";
import moment from "moment/moment";
import { Badge, Col, Form, FormGroup } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import useAlert from "../../../hooks/useAlert";
import { serialize } from "object-to-formdata";
import AppAlert from "../../Shared/AppAlert";
import AppInput from "../../Shared/AppInput";

const PaymentStatistics = ({ history, location, match, ...props }) => {
  const [data, setData] = useState([]);
  const [fetching, setFetching] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [setting, setSetting] = useState({});
  const [modal, setModal] = useState({ settingEditForm: false });

  // Top utilisateurs avec montants en USD (déplacé depuis PaymentCashout)
  const [topUsersUsd, setTopUsersUsd] = useState([]);
  const [topUsersUsdTotals, setTopUsersUsdTotals] = useState({});
  const [fetchingTopUsersUsd, setFetchingTopUsersUsd] = useState(true);

  const totalWalletToPay =
    Number(data?.totals?.total_wallet_balance || 0) -
    Number(data?.totals?.cashout_user_coins || 0);

  const totalLikesToPay =
    Number(data?.totals?.total_soutiens_count || 0) -
    Number(data?.totals?.cashout_user_likes || 0);

  const totalViewsToPay =
    Number(data?.totals?.total_views_count || 0) -
    Number(data?.totals?.cashout_user_views || 0);

  const [alert, setAlert, onClose] = useAlert();

  const initialValues = {
    user_wallet_balance: 0,
  };

  const onEdit = () => {
    formik.setValues({
      ...initialValues,
      user_wallet_balance:
        Number(data?.official_account?.user_wallet_balance)?.toFixed(0) || 0,
    });
    setModal((state) => ({ ...state, settingEditForm: true }));
  };

  const navigateToUserProfile = (user) => {
    history.push(`/users/${user?.user_username}`);
  };

  const navigateToCashout = () => {
    history.push("/payments/cashout");
  };

  const fetchData = async (params = {}) => {
    try {
      const response = await httpService.get(`/payments/statistics`, {
        params,
      });
      console.log("Fetch payments statistics response:", response);
      setData(response.data.data);
    } catch (error) {
      console.error("Fetch payments statistics error:", error);
    } finally {
      setFetching(false);
    }
  };

  const fetchTopUsersUsd = async () => {
    try {
      const response = await httpService.get(`/payments/top-users-usd`);
      const payload = response?.data?.data || response?.data || {};

      const usersWrapper = payload.users || {};
      const items = Array.isArray(usersWrapper)
        ? usersWrapper
        : usersWrapper.data || [];

      setTopUsersUsd(items);
      setTopUsersUsdTotals(payload.totals || {});
    } catch (error) {
      console.error("Fetch payments top users usd error:", error);
    } finally {
      setFetchingTopUsersUsd(false);
    }
  };

  useEffect(() => {
    try {
      fetchData({});
      fetchTopUsersUsd();
    } catch (e) {
      throw e;
    }
  }, []);

  const onSubmit = async (values) => {
    setSubmitting(true);
    setAlert(null);

    const formData = serialize(values, {
      indices: true,
      booleansAsIntegers: true,
    });

    try {
      const { data: response } = await httpService.post(
        `/payments/official-balance`,
        formData
      );
      setData((state) => ({ ...state, official_account: response?.data }));

      onCancelEdit();
    } catch ({ response }) {
      console.log("Get payment statistique error:", response);
      const { data, status } = response;

      if (response && status === 422) {
        setAlert({
          type: "danger",
          message: extractResponseValidationErrors(data)[0],
        });
      } else if (response && status === 500) {
        setAlert({
          type: "danger",
          message:
            "Erreur de traitement, veuillez contacter les administrateurs",
        });
      }
    } finally {
      setSubmitting(false);
    }
  };

  const formik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      user_wallet_balance: Yup.string().nullable(),
    }),
    onSubmit,
  });

  const onCancelEdit = () => {
    formik.resetForm({ ...initialValues });
    setAlert(null);
    setModal((state) => ({ ...state, settingEditForm: false }));
  };

  const renderLoadingCard = (label = "Chargement des données...") => (
    <div className="card bg-white border-0 shadow-none mb-0">
      <div className="card-body text-center py-4">
        <FecthingSpinner />
        <p className="text-muted mt-2 mb-0">{label}</p>
      </div>
    </div>
  );

  return (
    <div className="container-fluid">
      <AppBreadcrumb title="Monétisation" />

      <div>
          <div className="col-md-12">
            <div className="card">
              {/* <div className="header"><h2>Autres indicateurs</h2></div> */}
              <div className="body">
                {fetching ? (
                  renderLoadingCard("Chargement des indicateurs de paiement...")
                ) : (
                  <div className="row text-center">
                  <div
                    className="col-md-4 border-right pb-4 pt-4"
                    title={numberWithSeparator(totalWalletToPay)}
                  >
                    <label className="mb-0">Total de coins à payer</label>
                    <h4 className="font-30 font-weight-bold text-col-blue text-success">
                      {formatCash(totalWalletToPay.toFixed(2))} USD
                    </h4>
                  </div>
                  <div
                    className="col-md-4 border-right pb-4 pt-4"
                    title={numberWithSeparator(totalLikesToPay?.toFixed(0))}
                  >
                    <label className="mb-0">Total de likes à payer</label>
                    <h4 className="font-30 font-weight-bold text-col-blue text-success">
                      {formatCash(totalLikesToPay?.toFixed(2))} USD
                    </h4>
                  </div>
                  <div
                    className="col-md-4 pb-4 pt-4"
                    title={numberWithSeparator(totalViewsToPay?.toFixed(0))}
                  >
                    <label className="mb-0">Total de vues à payer</label>
                    <h4 className="font-30 font-weight-bold text-col-blue text-success">
                      {formatCash(totalViewsToPay?.toFixed(2))} USD
                    </h4>
                  </div>
                  <div
                    className="col-md-4 border-top border-right pb-4 pt-4"
                    title={numberWithSeparator(
                      data?.totals?.cashout_user_coins?.toFixed(2)
                    )}
                  >
                    <label className="mb-0">Total de coins encaissés</label>
                    <h4 className="font-30 font-weight-bold text-col-blue text-danger">
                      {formatCash(data?.totals?.cashout_user_coins?.toFixed(2))}{" "}
                      USD
                    </h4>
                  </div>
                  <div
                    className="col-md-4 border-top border-right pb-4 pt-4"
                    title={numberWithSeparator(
                      data?.totals?.cashout_user_likes?.toFixed(0)
                    )}
                  >
                    <label className="mb-0">Total de likes encaissés</label>
                    <h4 className="font-30 font-weight-bold text-col-blue text-danger">
                      {formatCash(data?.totals?.cashout_user_likes?.toFixed(2))}{" "}
                      USD
                    </h4>
                  </div>
                  <div
                    className="col-md-4 border-top pb-4 pt-4"
                    title={numberWithSeparator(
                      data?.totals?.cashout_user_views?.toFixed(0)
                    )}
                  >
                    <label className="mb-0">Total de vues encaissés</label>
                    <h4 className="font-30 font-weight-bold text-col-blue text-danger">
                      {formatCash(data?.totals?.cashout_user_views?.toFixed(2))}{" "}
                      USD
                    </h4>
                  </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="row clearfix">
            <div className="col-md-12">
              <div className="card">
                <div className="font-weight-normal">
                  <h5>Compte officiel MyOpinion</h5>
                </div>

                <div className="table-responsive">
                  <table className="table table-hover table-custom">
                    <thead>
                      <tr>
                        <th>Photo</th>
                        <th>Utilisateur</th>
                        <th>Coins</th>
                        <th>Opinions</th>
                        <th>Fans</th>
                        <th>Inscription</th>
                        <th>Dernière activité</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {fetching ? (
                        <tr>
                          <td colSpan="8" className="text-center py-4">
                            {renderLoadingCard(
                              "Chargement du compte officiel MyOpinion..."
                            )}
                          </td>
                        </tr>
                      ) : (
                        <tr
                          // onClick={() => navigateToUserProfile(data?.official_account)}
                          style={{ cursor: "pointer" }}
                        >
                          <td className="w60">
                            <img
                              src={
                                data?.official_account?.prof_picture ||
                                MyOpinionLogo
                              }
                              data-toggle="tooltip"
                              data-placement="top"
                              alt={`@(${data?.official_account?.user_username})`}
                              className="w35 rounded"
                              style={{ objectFit: "cover" }}
                            />
                          </td>
                          <td>
                            {getUserFullName(data?.official_account, true)}{" "}
                            {data?.official_account.user_verified && (
                              <i
                                style={{ cursor: "pointer" }}
                                title="Verified"
                                className="fa fa-check-circle-o text-primary mr-1"
                              />
                            )}
                            {data?.official_account.user_gold && (
                              <i
                                style={{ cursor: "pointer" }}
                                title="Premium / Gold"
                                className="fa fa-star text-warning mr-1"
                              />
                            )}
                          </td>
                          <td className="text-success font-weight-bold">
                            {Number(
                              data?.official_account?.user_wallet_balance
                            )?.toFixed(0)}{" "}
                            Coins (
                            {(
                              data?.official_account?.user_wallet_balance *
                              data?.totals?.coin_exchange_usd
                            )?.toFixed(2)}{" "}
                            USD)
                          </td>
                          <td>
                            {formatCash(data?.official_account?.opinions_count)}
                          </td>
                          <td>
                            <td className="text-center">
                              {formatCash(
                                data?.official_account?.friends_invited_count +
                                  data?.official_account?.friends_accepted_count +
                                  data?.official_account?.followers_count || 0
                              )}
                            </td>
                          </td>
                          <td>
                            {moment(
                              data?.official_account?.user_created_at
                            ).format("DD/MM/YYYY HH:mm")}
                          </td>
                          <td>
                            {moment(
                              data?.official_account?.user_last_seen
                            ).format("DD/MM/YYYY HH:mm")}
                          </td>
                          <td>
                            <button
                              className="btn btn-success text-white btn-sm mr-1 font-weight-bold"
                              onClick={onEdit}
                            >
                              <span>Modifier</span>
                            </button>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          {/* Top utilisateurs avec montants en USD (déplacé depuis PaymentCashout) */}
          <div className="row clearfix">
            <div className="col-md-12">
              <div className="card">
                <div className="font-weight-normal mb-3 d-flex justify-content-between align-items-center">
                  <h5>Top des comptes monétisés</h5>
                  <div className="text-right">
                    <button
                      type="button"
                      className="btn btn-primary font-weight-bold"
                      onClick={navigateToCashout}
                    >
                      Aller à la page cashout
                    </button>
                  </div>
                </div>

                <div className="table-responsive">
                  <table className="table table-hover table-custom spacing8">
                    <thead>
                      <tr>
                        <th>Photo</th>
                        <th>Utilisateur</th>
                        <th>Followers</th>
                        <th>Coins (USD)</th>
                        <th>Likes (USD)</th>
                        <th>Vues (USD)</th>
                        <th>Total (USD)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {fetchingTopUsersUsd ? (
                        <tr>
                          <td colSpan="7" className="text-center py-4">
                            {renderLoadingCard(
                              "Chargement du top des comptes monétisés..."
                            )}
                          </td>
                        </tr>
                      ) : (
                        topUsersUsd?.map((row, index) => {
                          const user = row.user || {};
                          const balances = row.balances || {};
                          const coins = balances.coins || {};
                          const likes = balances.likes || {};
                          const views = balances.views || {};

                          return (
                            <tr
                              key={user.user_id || index}
                              onClick={() => navigateToUserProfile(user)}
                              style={{ cursor: "pointer" }}
                            >
                              <td className="w60">
                                <img
                                  src={user.prof_picture || MyOpinionLogo}
                                  alt={`@(${user.user_username})`}
                                  className="w35 rounded"
                                  style={{ objectFit: "cover" }}
                                />
                              </td>
                              <td>{getUserFullName(user, true)}</td>
                              <td
                                className={`text-center font-weight-bold ${
                                  (row.all_followers_count || 0) > 1000
                                    ? "text-success"
                                    : "text-danger"
                                }`}
                              >
                                {formatCash(row.all_followers_count || 0)}
                              </td>
                              <td>
                                {formatCash(coins.usd || 0)} USD (
                                {formatCash(coins.amount || 0)})
                              </td>
                              <td>
                                {formatCash(likes.usd || 0)} USD (
                                {formatCash(likes.amount || 0)})
                              </td>
                              <td>
                                {formatCash(views.usd || 0)} USD (
                                {formatCash(views.amount || 0)})
                              </td>
                              <td
                                className={`text-center font-weight-bold ${
                                  (balances.total_usd || 0) >= 100
                                    ? "text-success"
                                    : "text-danger"
                                }`}
                              >
                                {formatCash(balances.total_usd || 0)} USD
                              </td>
                            </tr>
                          );
                        })
                      )}
                      {!fetchingTopUsersUsd &&
                      (!topUsersUsd || topUsersUsd.length === 0) ? (
                        <tr>
                          <td colSpan="7" className="text-center">
                            Aucun utilisateur trouvé.
                          </td>
                        </tr>
                      ) : null}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div className="row clearfix">
            <div className="col-md-12">
              <div className="card">
                <div className="font-weight-normal">
                  <h5>
                    Top 10 des utilisateurs {process.env.REACT_APP_APP_NAME}{" "}
                    avec le plus de coins
                  </h5>
                </div>
                <div className="table-responsive">
                  <table className="table table-hover table-custom spacing8">
                    <thead>
                      <tr>
                        <th>Photo</th>
                        <th>Utilisateur</th>
                        <th>Coins</th>
                        <th>Followers</th>
                        <th>Potes</th>
                        <th>Fans</th>
                        <th>Opinions</th>
                        <th>Inscription</th>
                        <th>Dernière activité</th>
                      </tr>
                    </thead>
                    <tbody>
                      {fetching ? (
                        <tr>
                          <td colSpan="9" className="text-center py-4">
                            {renderLoadingCard(
                              "Chargement du top utilisateurs par coins..."
                            )}
                          </td>
                        </tr>
                      ) : data?.top_wallet?.length > 0 ? (
                        data?.top_wallet?.map((obj) => (
                        <tr
                          key={obj?.user_id}
                          onClick={() => navigateToUserProfile(obj)}
                          style={{ cursor: "pointer" }}
                        >
                          <td className="w60">
                            <img
                              src={obj?.prof_picture || MyOpinionLogo}
                              data-toggle="tooltip"
                              data-placement="top"
                              alt={`@(${obj?.user_username})`}
                              className="w35 rounded"
                              style={{ objectFit: "cover" }}
                            />
                          </td>
                          <td>
                            {getUserFullName(obj, true)}{" "}
                            {obj.user_verified && (
                              <i
                                style={{ cursor: "pointer" }}
                                title="Verified"
                                className="fa fa-check-circle-o text-primary mr-1"
                              />
                            )}
                            {obj.user_gold && (
                              <i
                                style={{ cursor: "pointer" }}
                                title="Premium / Gold"
                                className="fa fa-star text-warning mr-1"
                              />
                            )}
                          </td>
                          <td
                            className={`font-weight-bold ${
                              (obj?.user_wallet_balance *
                                data?.totals?.coin_exchange_usd || 0) >= 100
                                ? "text-success"
                                : "text-danger"
                            }`}
                          >
                            {formatNumber(
                              Number(obj?.user_wallet_balance)?.toFixed(0)
                            )}{" "}
                            Coins (
                            {(
                              obj?.user_wallet_balance *
                              data?.totals?.coin_exchange_usd
                            )?.toFixed(2)}{" "}
                            USD)
                          </td>
                          <td
                            className={`text-center ${
                              (obj?.all_followers_count || 0) > 1000
                                ? "text-success"
                                : "text-danger"
                            }`}
                          >
                            {formatCash(obj?.all_followers_count || 0)}
                          </td>
                          <td className="text-center">
                            {formatCash(
                              obj?.friends_invited_count +
                                obj?.friends_accepted_count || 0
                            )}
                          </td>
                          <td className="text-center">
                            {formatCash(obj?.followers_count || 0)}
                          </td>
                          <td>{formatCash(obj?.opinions_count)}</td>
                          <td>
                            {moment(obj?.user_created_at).format(
                              "DD/MM/YYYY HH:mm"
                            )}
                          </td>
                          <td>
                            {moment(obj?.user_last_seen).format(
                              "DD/MM/YYYY HH:mm"
                            )}
                          </td>
                        </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="9" className="text-center text-muted">
                            Aucun utilisateur trouvé.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div className="row clearfix">
            <div className="col-md-12">
              <div className="card">
                <div className="font-weight-normal">
                  <h5>
                    Top 10 des utilisateurs {process.env.REACT_APP_APP_NAME}{" "}
                    avec le plus de likes
                  </h5>
                </div>
                <div className="table-responsive">
                  <table className="table table-hover table-custom spacing8">
                    <thead>
                      <tr>
                        <th>Photo</th>
                        <th>Utilisateur</th>
                        <th>Likes</th>
                        <th>Followers</th>
                        <th>Potes</th>
                        <th>Fans</th>
                        <th>Opinions</th>
                        <th>Inscription</th>
                        <th>Dernière activité</th>
                      </tr>
                    </thead>
                    <tbody>
                      {fetching ? (
                        <tr>
                          <td colSpan="9" className="text-center py-4">
                            {renderLoadingCard(
                              "Chargement du top utilisateurs par likes..."
                            )}
                          </td>
                        </tr>
                      ) : data?.top_likes?.length > 0 ? (
                        data?.top_likes?.map((obj) => (
                        <tr
                          key={obj?.user_id}
                          onClick={() => navigateToUserProfile(obj)}
                          style={{ cursor: "pointer" }}
                        >
                          <td className="w60">
                            <img
                              src={obj?.prof_picture || MyOpinionLogo}
                              data-toggle="tooltip"
                              data-placement="top"
                              alt={`@(${obj?.user_username})`}
                              className="w35 rounded"
                              style={{ objectFit: "cover" }}
                            />
                          </td>
                          <td>
                            {getUserFullName(obj, true)}{" "}
                            {obj.user_verified && (
                              <i
                                style={{ cursor: "pointer" }}
                                title="Verified"
                                className="fa fa-check-circle-o text-primary mr-1"
                              />
                            )}
                            {obj.user_gold && (
                              <i
                                style={{ cursor: "pointer" }}
                                title="Premium / Gold"
                                className="fa fa-star text-warning mr-1"
                              />
                            )}
                          </td>
                          <td
                            className={`font-weight-bold ${
                              (obj?.sond_soutiens_count *
                                data?.totals?.like_exchange_usd || 0) >= 100
                                ? "text-success"
                                : "text-danger"
                            }`}
                          >
                            {formatCash(obj?.sond_soutiens_count?.toFixed(0))}{" "}
                            Likes (
                            {(
                              obj?.sond_soutiens_count *
                              data?.totals?.like_exchange_usd
                            )?.toFixed(2)}{" "}
                            USD)
                          </td>
                          <td
                            className={`text-center ${
                              (obj?.all_followers_count || 0) > 1000
                                ? "text-success"
                                : "text-danger"
                            }`}
                          >
                            {formatCash(obj?.all_followers_count || 0)}
                          </td>
                          <td className="text-center">
                            {formatCash(
                              obj?.friends_invited_count +
                                obj?.friends_accepted_count || 0
                            )}
                          </td>
                          <td className="text-center">
                            {formatCash(obj?.followers_count || 0)}
                          </td>
                          <td>{formatCash(obj?.opinions_count)}</td>
                          <td>
                            {moment(obj?.user_created_at).format(
                              "DD/MM/YYYY HH:mm"
                            )}
                          </td>
                          <td>
                            {moment(obj?.user_last_seen).format(
                              "DD/MM/YYYY HH:mm"
                            )}
                          </td>
                        </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="9" className="text-center text-muted">
                            Aucun utilisateur trouvé.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div className="row clearfix">
            <div className="col-md-12">
              <div className="card">
                <div className="font-weight-normal">
                  <h5>
                    Top 10 des utilisateurs {process.env.REACT_APP_APP_NAME}{" "}
                    avec le plus de vues
                  </h5>
                </div>
                <div className="table-responsive">
                  <table className="table table-hover table-custom spacing8">
                    <thead>
                      <tr>
                        <th>Photo</th>
                        <th>Utilisateur</th>
                        <th>Vues</th>
                        <th>Followers</th>
                        <th>Potes</th>
                        <th>Fans</th>
                        <th>Opinions</th>
                        <th>Inscription</th>
                        <th>Dernière activité</th>
                      </tr>
                    </thead>
                    <tbody>
                      {fetching ? (
                        <tr>
                          <td colSpan="9" className="text-center py-4">
                            {renderLoadingCard(
                              "Chargement du top utilisateurs par vues..."
                            )}
                          </td>
                        </tr>
                      ) : data?.top_views?.length > 0 ? (
                        data?.top_views?.map((obj) => (
                        <tr
                          key={obj?.user_id}
                          onClick={() => navigateToUserProfile(obj)}
                          style={{ cursor: "pointer" }}
                        >
                          <td className="w60">
                            <img
                              src={obj?.prof_picture || MyOpinionLogo}
                              data-toggle="tooltip"
                              data-placement="top"
                              alt={`image`}
                              className="w35 rounded"
                              style={{ objectFit: "cover" }}
                            />
                          </td>
                          <td>
                            {getUserFullName(obj, true)}{" "}
                            {obj.user_verified ? (
                              <i
                                style={{ cursor: "pointer" }}
                                title="Verified"
                                className="fa fa-check-circle-o text-primary mr-1"
                              />
                            ) : null}
                            {obj.user_gold ? (
                              <i
                                style={{ cursor: "pointer" }}
                                title="Premium / Gold"
                                className="fa fa-star text-warning mr-1"
                              />
                            ) : null}
                          </td>
                          <td className={`font-weight-bold ${
                            (Number(obj?.sond_views_total) *
                              data?.totals?.view_exchange_usd || 0) >= 100
                              ? "text-success"
                              : "text-danger"
                          }`}>
                            {formatCash(
                              Number(obj?.sond_views_total)?.toFixed(0)
                            )}{" "}
                            Vues (
                            {(
                              Number(obj?.sond_views_total) *
                              data?.totals?.view_exchange_usd
                            )?.toFixed(2)}{" "}
                            USD)
                          </td>
                          <td
                            className={`text-center ${
                              (obj?.all_followers_count || 0) > 1000
                                ? "text-success"
                                : "text-danger"
                            }`}
                          >
                            {formatCash(obj?.all_followers_count || 0)}
                          </td>
                          <td className="text-center">
                            {formatCash(
                              obj?.friends_invited_count +
                                obj?.friends_accepted_count || 0
                            )}
                          </td>
                          <td className="text-center">
                            {formatCash(obj?.followers_count || 0)}
                          </td>
                          <td>{formatCash(obj?.opinions_count)}</td>
                          <td>
                            {moment(obj?.user_created_at).format(
                              "DD/MM/YYYY HH:mm"
                            )}
                          </td>
                          <td>
                            {moment(obj?.user_last_seen).format(
                              "DD/MM/YYYY HH:mm"
                            )}
                          </td>
                        </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="9" className="text-center text-muted">
                            Aucun utilisateur trouvé.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          {/* Modal edit official account */}
          <div
            className={`modal fade ${
              modal.settingEditForm ? "d-block show" : ""
            }`}
            id="exampleModal"
            onClick={() => null}
          >
            <div className="modal-dialog modal-lg" role="document">
              <Form onSubmit={formik.handleSubmit}>
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">
                      Mise à jour du solde du compte MyOpinion
                    </h5>
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                      onClick={onCancelEdit}
                    >
                      <span aria-hidden="true">×</span>
                    </button>
                  </div>
                  <div
                    className="modal-body"
                    style={{ maxHeight: "76vh", overflowY: "auto" }}
                  >
                    {alert && (
                      <AppAlert onClose={onClose} type={alert.type}>
                        {alert.message}
                      </AppAlert>
                    )}
                    <FormGroup>
                      <AppInput
                        label="Solde de MyOpinion (COIN)"
                        name="user_wallet_balance"
                        error={formik.errors.user_wallet_balance}
                        touched={formik.touched.user_wallet_balance}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.user_wallet_balance}
                        type="number"
                        step="1"
                      />
                    </FormGroup>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className={`btn btn-round btn-danger font-weight-bold`}
                      disabled={submitting}
                      data-dismiss="modal"
                      onClick={onCancelEdit}
                    >
                      <span className="fa fa-times"></span> Annuler
                    </button>
                    <button
                      type="submit"
                      className={`btn btn-round btn-success font-weight-bold`}
                      disabled={submitting}
                    >
                      <span className="fa fa-save"></span>{" "}
                      {submitting ? "Enregistrement..." : "Enregistrer"}
                    </button>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
    </div>
  );
};

export default PaymentStatistics;
